// in src/MyUrlField.js
import React from "react";

import { withStyles } from "@material-ui/core/styles";
import FileCopy from "@material-ui/icons/FileCopy";

const styles = {
  link: {
    textDecoration: "none",
  },
  icon: {
    width: "0.5em",
    paddingLeft: 2,
  },
};

const MyUrlField = ({ record = {}, source, filename, classes }) => {
  const myLink = `${record[source]}`;
  const shortName = record[filename] ? record[filename].slice(0, 15) : "";
  return (
    <a href={myLink} className={classes.link}>
      {shortName}
      <FileCopy className={classes.icon} />
    </a>
  );
};

export default withStyles(styles)(MyUrlField);



// WEBPACK FOOTER //
// ./src/MyUrlField.js